import React, { useEffect, useState } from "react";
import "./Empresa.css";
import { authFetch } from "../utils/authFetch";
import { Boton, EncabezadoPagina, Iconos } from "../componentes/base";

export default function Empresa() {
  const [form, setForm] = useState(null);
  const [guardando, setGuardando] = useState(false);

  async function cargar() {
    try {
      const res = await authFetch("/api/empresa/info");
      const data = await res.json();
      if (data.ok) setForm(data.empresa || {});
    } catch (e) {
      console.error("Error cargando empresa:", e);
      setForm({});
    }
  }

  useEffect(() => {
    cargar();
  }, []);

  function actualizar(campo, valor) {
    setForm((prev) => ({ ...(prev || {}), [campo]: valor }));
  }

  async function guardar() {
    try {
      setGuardando(true);
      const res = await authFetch("/api/empresa/actualizar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form || {}),
      });
      await res.json();
    } catch (e) {
      console.error("Error guardando empresa:", e);
    } finally {
      setGuardando(false);
    }
  }

  if (!form) return <div className="empresa-loading">Cargando...</div>;

  return (
    <div className="empresa-page">
      <EncabezadoPagina
        icono={Iconos.empresa}
        titulo="Datos de la empresa"
        resumen="Aparecen en los tickets, los estados de cuenta y el chatbot."
      />

      <div className="empresa-card">
        <div className="input-group">
          <label>Nombre</label>
          <input
            value={form.nombre ?? ""}
            onChange={(e) => actualizar("nombre", e.target.value)}
            autoComplete="organization"
          />
        </div>

        <div className="input-group">
          <label>RFC</label>
          <input
            value={form.rfc ?? ""}
            onChange={(e) => actualizar("rfc", e.target.value)}
            autoComplete="off"
          />
        </div>

        <div className="input-group">
          <label>Dirección</label>
          <textarea
            value={form.direccion ?? ""}
            onChange={(e) => actualizar("direccion", e.target.value)}
          />
        </div>

        <div className="input-group">
          <label>Municipio</label>
          <input
            value={form.municipio ?? ""}
            onChange={(e) => actualizar("municipio", e.target.value)}
            autoComplete="address-level2"
          />
        </div>

        <div className="input-group">
          <label>Teléfono</label>
          <input
            value={form.telefono ?? ""}
            onChange={(e) => actualizar("telefono", e.target.value)}
            autoComplete="tel"
          />
        </div>

        <div className="input-group">
          <label>Correo</label>
          <input
            value={form.correo ?? ""}
            onChange={(e) => actualizar("correo", e.target.value)}
            autoComplete="email"
          />
        </div>

        <div className="input-group">
          <label>Sitio Web</label>
          <input
            value={form.sitio_web ?? ""}
            onChange={(e) => actualizar("sitio_web", e.target.value)}
            autoComplete="url"
          />
        </div>

        <h3 className="empresa-section-title">
          <Iconos.hora size={16} strokeWidth={1.8} />
          Horarios
        </h3>

        <div className="input-group">
          <label>Lunes a Viernes</label>
          <input
            value={form.horario_lunes_viernes ?? ""}
            onChange={(e) => actualizar("horario_lunes_viernes", e.target.value)}
            autoComplete="off"
          />
        </div>

        <div className="input-group">
          <label>Sábado</label>
          <input
            value={form.horario_sabado ?? ""}
            onChange={(e) => actualizar("horario_sabado", e.target.value)}
            autoComplete="off"
          />
        </div>

        <div className="input-group">
          <label>Domingo</label>
          <input
            value={form.horario_domingo ?? ""}
            onChange={(e) => actualizar("horario_domingo", e.target.value)}
            autoComplete="off"
          />
        </div>

        <Boton
          className="empresa-guardar"
          icono={Iconos.confirmar}
          cargando={guardando}
          onClick={guardar}
          type="button"
        >
          Guardar cambios
        </Boton>
      </div>
    </div>
  );
}
